import { render, staticRenderFns } from "./updateSection.vue?vue&type=template&id=1aed5d11&scoped=true&"
import script from "./updateSection.vue?vue&type=script&lang=js&"
export * from "./updateSection.vue?vue&type=script&lang=js&"
import style0 from "./updateSection.vue?vue&type=style&index=0&id=1aed5d11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed5d11",
  null
  
)

export default component.exports